export default __webpack_public_path__ + "static/media/laundry.503dc1e0.svg";